export * from "./UserInfoObservable";
//# sourceMappingURL=index.js.map